// extracted by mini-css-extract-plugin
export default {"galleryGrid2x2":"GalleryGrid2x2_galleryGrid2x2__67n2R"};